import { Directive, OnInit, Input, TemplateRef, ViewContainerRef, ElementRef } from '@angular/core';
import { UserService } from '../services/user.service';

@Directive({
  selector: '[appHasPermission]',
})
export class HasPermissionDirective implements OnInit {
  private userPermissions: string[];
  private permissions = [];
  private logicalOp = 'AND';
  private isHidden = true;

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.permissions().then((permissions) => {
      this.userPermissions = permissions;
      this.updateView();
    });
  }

  @Input()
  set appHasPermission(val) {
    this.permissions = val;
    this.updateView();
  }

  @Input()
  set appHasPermissionOp(permop) {
    this.logicalOp = permop;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission()) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
    } else {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    let hasPermission = false;

    if (this.userPermissions) {
      for (const checkPermission of this.permissions) {
        const permissionFound = this.userPermissions.find((x) => x.toUpperCase() === checkPermission.toUpperCase());

        if (permissionFound) {
          hasPermission = true;

          if (this.logicalOp === 'OR') {
            break;
          }
        } else {
          hasPermission = false;
          if (this.logicalOp === 'AND') {
            break;
          }
        }
      }
    }
    return hasPermission;
  }
}
